import { getCookie, setCookie, delCookie } from './handleCookie.js'

import { refreshToken } from './../../api/accountapi.js'

// export let phoneReg = /^1[3|4|5|6|7|8|9]\d{9}$/;
export let phoneReg = /^1(3|4|5|6|7|8|9)\d{9}$/;

export let passwordReg = /[\dA-z]{6,16}$/;
export let regAllNum = /^[0-9]+.?[0-9]*$/; //判断字符串是否为数字 ，判断正整数用
export let regPlusNum = /^[1-9]+[0-9]*]*$/; //判断正整数用

export let searchByPicDomainName = "https://public-resource-1252926746.cos.ap-shanghai.myqcloud.com/"

let domain = location.host;


let api
if(process.env.NODE_ENV === 'development') {
	// api = '//192.168.1.24:8090/';
  api = '//192.168.1.241:8016/'
} else {
	api = '//www.originoo.com/api/';
}

//测试搜索用
// api = 'https://www.originoo.com/api/';

export let apiURL = api
export let accountApiURL = '//account.originoo.com/'

let tencent = '//frontend.originoo.com';

export let webDomainName = '//www.originoo.com/';
export let webDomainName2 = 'www.originoo.com/'

//old  https://p.qiao.baidu.com/cps/chat?siteId=10187721&userId=22628659
//new
export let onlineServiceConfig = ''


//判断是否登录
export let judgeLogin = judgelogin();

function judgelogin() {

	if(getCookie('token')) {
		return true
	} else {
		return false
	}
}
//解析token
export function analysisToken() {
	let obj = {};
	let token = getCookie('token');

	if(token) {

		//		//console.log(token,33);

		let userToken = token.substr(7).split(".")[1];
		userToken = Base64.decode(userToken);
		////console.log(userToken, '445_1')
		userToken = JSON.parse(userToken)
		//console.log(userToken, '445_2')
		let userinfo = JSON.parse(userToken.sub)
		//console.log(userinfo, 4)

		obj = userinfo;

		return obj
	}

};

//修改个人信息 刷新token

export function modifyUserMsgReplaceToken() {
	let token = getCookie('token');
	let isAutoLogin = getCookie('isAutoLogin') * 1;

	refreshToken({
		//		token: token
	}).then(res => {
		////console.log(res, '修改个人信息 刷新token')
		let keys = Object.keys(res.data)
		let newtoken = res.data[keys[0]]

		let userInfoCode = newtoken.substr(7).split(".")[1];
		let authorization = Base64.decode(userInfoCode); //base64解码
		let JsonInfo = eval('(' + authorization + ')'); //转化成json
		let userinfo = eval('(' + JsonInfo.sub + ')'); //用户的个人信息
		if(isAutoLogin) {
			////console.log(isAutoLogin, '是否自动登录', 6666)
			setCookie('isAutoLogin', 1, 1);
			setCookie('headImg', userinfo.headImage, 1); //cookie设置头像
			setCookie('id', userinfo.id, 1); //cookie设置id
			setCookie('username', userinfo.username, 1); //cookie设置用户名
			setCookie('userType', JsonInfo.scopes, 1); //cookie设置用户类型,数据为string类型

			setCookie('token', newtoken, 1); //cookie设置token
		} else {
			////console.log(isAutoLogin, '是否自动登录', 777)
			setCookie('isAutoLogin', 0, 1);
			setCookie('headImg', userinfo.headImage); //cookie设置头像
			setCookie('id', userinfo.id); //cookie设置id
			setCookie('username', userinfo.username); //cookie设置用户名
			setCookie('userType', JsonInfo.scopes); //cookie设置用户类型,数据为string类型

			setCookie('token', newtoken); //cookie设置token
		}
	})

}

//token过期时，用old token 替换新的token

export function replaceToken() {
	let token = getCookie('token');
	let isAutoLogin = getCookie('isAutoLogin') * 1;
	if(token) {
		//
		let tokenInfoCode = token.substr(7).split(".")[1];
		let tokenInfoCodeAuthorization = Base64.decode(tokenInfoCode); //base64解码
		let tokenInfo = eval('(' + tokenInfoCodeAuthorization + ')'); //转化成json

		//判断token是否过期
		//token 过期时间 JsonInfo.exp
		let nowtime = (new Date()).getTime()
		let expiretime = tokenInfo.exp * 1000;

		////console.log(isAutoLogin, '是否自动登录')
		//		//console.log(new Date(expiretime),'expiretime')

		//时间差
		let timediff = (expiretime - nowtime) / 60 / 60 / 1000;

		////console.log(timediff, '时间差')

		//3个小时 10,800,000‬ ms

		if(timediff <= 0) {
			delCookie('token')
			return ''
		} else if(timediff < 3) {
			refreshToken({}).then(res => {
				////console.log(res, 'token过期refreshToken')
				let keys = Object.keys(res.data)
				//				//console.log(keys, keys[0], 'newtoken')
				let newtoken = res.data[keys[0]]

				//				//console.log(keys, 'newtoken')
				//				//console.log(newtoken, 'newtokennewtoken')

				let userInfoCode = newtoken.substr(7).split(".")[1];
				let authorization = Base64.decode(userInfoCode); //base64解码
				let JsonInfo = eval('(' + authorization + ')'); //转化成json
				let userinfo = eval('(' + JsonInfo.sub + ')'); //用户的个人信息
				if(isAutoLogin) {
					//console.log(isAutoLogin, '是否自动登录', 6666)
					setCookie('isAutoLogin', 1, 1);
					setCookie('headImg', userinfo.headImage, 1); //cookie设置头像
					setCookie('id', userinfo.id, 1); //cookie设置id
					setCookie('username', userinfo.username, 1); //cookie设置用户名
					setCookie('userType', JsonInfo.scopes, 1); //cookie设置用户类型,数据为string类型

					setCookie('token', newtoken, 1); //cookie设置token
				} else {
					//console.log(isAutoLogin, '是否自动登录', 777)
					setCookie('isAutoLogin', 0, 1);
					setCookie('headImg', userinfo.headImage); //cookie设置头像
					setCookie('id', userinfo.id); //cookie设置id
					setCookie('username', userinfo.username); //cookie设置用户名
					setCookie('userType', JsonInfo.scopes); //cookie设置用户类型,数据为string类型

					setCookie('token', newtoken); //cookie设置token
				}
				return token
			})

		} else {
			return token
		}

	} else {
		return ''

	}

}

//frontend.originoo.com/originoo_web/logo/logo.png

//对数组排序 内部是{} 根据对象的某一参数

export function getSortArr(list, index) {

	let arr = list.sort(function(a, b) {
		var value1 = a[index];
		var value2 = b[index];
		return value1 - value2;
	})
	return arr
}
//export function getSortArr(list,index){
//	 let arr = list.sort(sss(index))
//	 return  arr
//}
//function sss(index){
//	return function(a, b) {
//		var value1 = a[index];
//		var value2 = b[index];
//		return value1 - value2;
//	}
//}
export function getTimeStr(time) {
	let dateTime = new Date(time);
	let Y = dateTime.getFullYear();
	let M = dateTime.getMonth() + 1;
	let D = dateTime.getDate();
	let h = dateTime.getHours();
	let m = dateTime.getMinutes();
	let s = dateTime.getSeconds();
	if(M < 10) {
		M = '0' + M
	}
	if(D < 10) {
		D = '0' + D
	}
	if(h < 10) {
		h = '0' + h
	}
	if(m < 10) {
		m = '0' + m
	}
	if(s < 10) {
		s = '0' + s
	}
	return Y + "年" + M + "月" + D + "日" + " " + h + ":" + m + ":" + s
}
//时间
export function getTimeStrYMDhm() {
	let dateTime = new Date();
	let Y = dateTime.getFullYear();
	let M = dateTime.getMonth() + 1;
	let D = dateTime.getDate();
	let h = dateTime.getHours();
	let m = dateTime.getMinutes();
	let s = dateTime.getSeconds();
	if(M < 10) {
		M = '0' + M
	}
	if(D < 10) {
		D = '0' + D
	}
	if(h < 10) {
		h = '0' + h
	}
	if(m < 10) {
		m = '0' + m
	}
	if(s < 10) {
		s = '0' + s
	}
	Y = Y.toString()
	M = M.toString()
	D = D.toString()
	h = h.toString()
	m = m.toString()
	s = s.toString()

	return Y + M + D + h + m
}

export function jsonEncryption(data) {
	let res = JSON.parse(JSON.stringify(data));
	return res

}

//图片搜索类型
export let searchTypeList = [{
		value: 'pic-vector',
		label: '全部图片'
	}, {
		value: 'pic',
		label: '创意图片'
	},
	{
		value: 'vector',
		label: '设计素材'
	}, {
		value: 'video',
		label: '创意视频'
	},
];

//图片排版辅助  瀑布流和横向排版
let picIndex = 0;
export function handlePicData(picdata) {
	////console.log('处理排版')
	let picArrAfter = []; //处理后的图片数组
	let dataLen = picdata.length;
	for(let i = 0; i < dataLen; i++) {
		picdata[i].islike = false;
		//		picdata[i].iscollect = false;

		if(picdata[i].width) {
			picArrAfter[i] = {
				index: picIndex++,
				style: {},
				width: picdata[i].width,
				height: picdata[i].height,
				data: picdata[i]
			}
		} else {
			picArrAfter[i] = {
				index: picIndex++,
				style: {},
				width: 200 + ~~(Math.random() * 50),
				height: 200 + ~~(Math.random() * 50),
				data: picdata[i]
			}
		}

	}
	return picArrAfter
};

//搜索页面的
let searchPicIndex = 0;
export function handlePicDataSearch(picdata) {
	////console.log('处理排版')
	let picArrAfter = []; //处理后的图片数组
	let dataLen = picdata.length;
	for(let i = 0; i < dataLen; i++) {
		picdata[i].islike = false;

		//		picdata[i].iscollect = false;
		picArrAfter[i] = {
			index: searchPicIndex++,
			style: {

			},
			width: picdata[i].width,
			height: picdata[i].height,
			isload: false,

			data: picdata[i]
		}
	}
	return picArrAfter
};

// 将整数转换成 时：分：秒的格式
 export function realFormatSecond(second) {
           let m=Math.floor(second/60);
                      let s=second%60;
                      if(s<10){
                          s="0"+s
                      }
                      return m+':'+s;
    };

//购物车授权列表
//图片
export let empowerTypePic1 = [{
		value: 'medium',
		label: '新媒体授权'
	},
	{
		value: 'standard',
		label: '标准授权'
	},
	{
		value: 'electronic-extend',
		label: '电子扩展授权'
	},
	{
		value: 'print-extend',
		label: '印刷扩展授权'
	},
	{
		value: 'currency-extend',
		label: '全用途扩展授权'
	}
];
//只有S号
export let empowerTypePic2 = [{
		value: 'medium',
		label: '新媒体授权'
	},
	{
		value: 'electronic-extend',
		label: '电子扩展授权'
	},
	{
		value: 'print-extend',
		label: '印刷扩展授权'
	},
	{
		value: 'currency-extend',
		label: '全用途扩展授权'
	}
]
//视频
export let empowerTypeVideo = [{
	value: 'standard',
	label: '标准授权'
}]

//下载记录页面的授权类型

export let authorizationTypeList = [{
		value: '',
		label: '全部'
	}, {
		value: 'medium',
		label: '新媒体'
	}, {
		value: 'standard',
		label: '标准'
	}, {
		value: 'electronic-extend',
		label: '电子扩展'
	}, {
		value: 'print-extend',
		label: '印刷扩展'
	}, {
		value: 'currency-extend',
		label: '全用途扩展'
	}

]

//价格页面
export let empowerRangeVideo = [
	//1允许 0 不允许
	{
		purpose: '互联网',
		empowerS: 1,
		empowerN: 1
	},
	{
		purpose: '移动互联网',
		empowerS: 1,
		empowerN: 1
	},
	{
		purpose: '社会化媒体（微博、微信）',
		empowerS: 1,
		empowerN: 1
	},
	{
		purpose: '光盘介质',
		empowerS: 1,
		empowerN: 1
	},
	{
		purpose: '现场演出',
		empowerS: 1,
		empowerN: 1
	},
	{
		purpose: '户外广告',
		empowerS: 1,
		empowerN: 1
	},
	{
		purpose: '电影、电视',
		empowerS: 0,
		empowerN: 1
	},
	{
		purpose: '敏感用途（医疗、药物、烟草、美容整容、保健品类广告及宣传）',
		empowerS: 0,
		empowerN: 1
	}

]
export let empowerRangePic = [{
		purpose: '网站、电子邮件、电子贺卡、电子杂志、电子图书、自媒体号（如微博、博客、微信公众号、头条号等）文章配图使用；',
		empowerS: 1,
		empowerN: 1,
		empowerE: 1,
		empowerP: 1,
		empowerA: 1
	},
	{
		purpose: '在线广告、移动设备广告（包括用于电商平台的网店海报、主图、商品详情页等）',
		empowerS: 1,
		empowerN: 1,
		empowerE: 1,
		empowerP: 1,
		empowerA: 1
	},
  {
    purpose: '移动应用程序、软件（仅限于非售卖类程序/软件)',
    empowerS: 1,
    empowerN: 1,
    empowerE: 1,
    empowerP: 1,
    empowerA: 1
  },
	{
		purpose: '线下印刷：宣传页、促销传单、海报、报刊、杂志、书籍、CD和DVD封面、包装等',
		empowerS: 0,
		empowerN: '限量50万份(书籍不包含封面封底)',
		empowerE: '限量50万份(书籍不包含封面封底)',
		empowerP: '不限量',
		empowerA: '不限量'
	},
	{
		purpose: '户外广告：楼宇、车身、灯箱、围挡、橱窗等 ',
		empowerS: 0,
		empowerN: 0,
		empowerE: 0,
		empowerP: 1,
		empowerA: 1
	},
	{
		purpose: '转售设计模板：软件/程序、APP皮肤/主题/壁纸',
		empowerS: 0,
		empowerN: 0,
		empowerE: 1,
		empowerP: 0,
		empowerA: 1
	}, {
		purpose: '转售商品、促销商品、赠品：包括但不限于纺织品、手机壳、贺卡、明信片、日历、杯子、T恤',
		empowerS: 0,
		empowerN: 0,
		empowerE: 0,
		empowerP: 1,
		empowerA: 1
	}, {
		purpose: '敏感用途：医疗、药物、烟草、整容、保健品类广告及宣传',
		empowerS: 0,
		empowerN: 0,
		empowerE: 0,
		empowerP: 0,
		empowerA: 1
	},
	{
		purpose: '标志、商标等LOGO的设计、制作与使用中',
		empowerS: 0,
		empowerN: 0,
		empowerE: 0,
		empowerP: 0,
		empowerA: 0
	},

	{
		purpose: '在电视、网络视频、电影等视频影像中使用',
		empowerS: 0,
		empowerN: 0,
		empowerE: 1,
		empowerP: 0,
		empowerA: 1
	}
];

//价格页面
export let commonProblemTypeList = [{
		src: '//frontend.originoo.com/originoo_web/price/accountreg_0.png',
		activesrc: '//frontend.originoo.com/originoo_web/price/accountreg_1.png',
		title: '账户与注册',
		isactive: false
	}, {
		src: '//frontend.originoo.com/originoo_web/price/buydownload_0.png',
		activesrc: '//frontend.originoo.com/originoo_web/price/buydownload_1.png',
		title: '购买与下载',
		isactive: false
	}, {
		src: '//frontend.originoo.com/originoo_web/price/copyrightuse_0.png',
		activesrc: '//frontend.originoo.com/originoo_web/price/copyrightuse_1.png',
		title: '版权和使用权限',
		isactive: false
	}, {
		src: '//frontend.originoo.com/originoo_web/price/invoiceaftersale_0.png',
		activesrc: '//frontend.originoo.com/originoo_web/price/invoiceaftersale_1.png',
		title: '发票与售后',
		isactive: false
	},

];

export let allPList = [{
		type: '240P',
		SPrice: '150',
		GPrice: '900'
	}, {
		type: '480P',
		SPrice: '300',
		GPrice: '1800'
	}, {
		type: '720P',
		SPrice: '500',
		GPrice: '3000'
	}, {
		type: '1080P',
		SPrice: '600',
		GPrice: '3600'
	}, {
		type: '4K',
		SPrice: '1500',
		GPrice: '9000'
	},

];


//风格

export let musicStyleList_ = [

	{
		"id": 305,
		"name": "Blues",
		"real": true,
		"parent": 163,
		"children": [],
		"weight": 3
	},
	{
		"id": 307,
		"name": "Hip-hop",
		"real": true,
		"parent": 163,
		"children": [{
				"id": 297,
				"name": "Trap Hip Hop",
				"real": false,
				"parent": 307,
				"children": [],
				"weight": 0
			},
			{
				"id": 397,
				"name": "匪帮说唱",
				"real": true,
				"parent": 307,
				"children": [],
				"weight": 0
			},
			{
				"id": 396,
				"name": "复古",
				"real": true,
				"parent": 307,
				"children": [],
				"weight": 0
			},
			{
				"id": 398,
				"name": "英国地下乐",
				"real": true,
				"parent": 307,
				"children": [],
				"weight": 0
			}
		],
		"weight": 12
	},
	{
		"id": 308,
		"name": "R&B",
		"real": false,
		"parent": 163,
		"children": [],
		"weight": 7
	},
	{
		"id": 310,
		"name": "乡村",
		"real": true,
		"parent": 163,
		"children": [],
		"weight": 9
	},
	{
		"id": 394,
		"name": "企业形象",
		"real": true,
		"parent": 163,
		"children": [],
		"weight": 18
	},
	{
		"id": 137,
		"name": "古典",
		"real": false,
		"parent": 163,
		"children": [{
				"id": 287,
				"name": "前卫交响",
				"real": true,
				"parent": 137,
				"children": [],
				"weight": 0
			},
			{
				"id": 142,
				"name": "古典交响",
				"real": true,
				"parent": 137,
				"children": [],
				"weight": 0
			},
			{
				"id": 140,
				"name": "室内乐",
				"real": true,
				"parent": 137,
				"children": [],
				"weight": 0
			},
			{
				"id": 286,
				"name": "歌剧",
				"real": true,
				"parent": 137,
				"children": [],
				"weight": 0
			},
			{
				"id": 139,
				"name": "现代交响",
				"real": true,
				"parent": 137,
				"children": [],
				"weight": 0
			},
			{
				"id": 141,
				"name": "电声交响",
				"real": true,
				"parent": 137,
				"children": [],
				"weight": 0
			}
		],
		"weight": 10
	},
	{
		"id": 103,
		"name": "古风",
		"real": true,
		"parent": 163,
		"children": [],
		"weight": 14
	},
	{
		"id": 303,
		"name": "拉丁",
		"real": true,
		"parent": 163,
		"children": [{
				"id": 315,
				"name": "Reggaeton/说唱",
				"real": false,
				"parent": 303,
				"children": [],
				"weight": 0
			},
			{
				"id": 313,
				"name": "Tropical",
				"real": false,
				"parent": 303,
				"children": [],
				"weight": 0
			},
			{
				"id": 312,
				"name": "巴萨诺瓦",
				"real": false,
				"parent": 303,
				"children": [],
				"weight": 0
			},
			{
				"id": 314,
				"name": "探戈/桑巴",
				"real": false,
				"parent": 303,
				"children": [],
				"weight": 0
			}
		],
		"weight": 1
	},
	{
		"id": 29,
		"name": "摇滚",
		"real": false,
		"parent": 163,
		"children": [{
				"id": 59,
				"name": "实验摇滚/后摇",
				"real": true,
				"parent": 29,
				"children": [],
				"weight": 0
			},
			{
				"id": 57,
				"name": "布鲁斯",
				"real": true,
				"parent": 29,
				"children": [],
				"weight": 0
			},
			{
				"id": 58,
				"name": "朋克",
				"real": true,
				"parent": 29,
				"children": [],
				"weight": 0
			},
			{
				"id": 100,
				"name": "流行摇滚",
				"real": true,
				"parent": 29,
				"children": [],
				"weight": 0
			},
			{
				"id": 61,
				"name": "独立摇滚",
				"real": true,
				"parent": 29,
				"children": [],
				"weight": 0
			},
			{
				"id": 60,
				"name": "金属",
				"real": true,
				"parent": 29,
				"children": [],
				"weight": 0
			}
		],
		"weight": 13
	},
	{
		"id": 134,
		"name": "放克",
		"real": false,
		"parent": 163,
		"children": [],
		"weight": 5
	},
	{
		"id": 31,
		"name": "新世纪",
		"real": false,
		"parent": 163,
		"children": [{
				"id": 301,
				"name": "新世纪实验",
				"real": true,
				"parent": 31,
				"children": [],
				"weight": 0
			},
			{
				"id": 102,
				"name": "新世纪电子",
				"real": true,
				"parent": 31,
				"children": [],
				"weight": 0
			},
			{
				"id": 144,
				"name": "新世纪交响/新世纪室内乐",
				"real": true,
				"parent": 31,
				"children": [],
				"weight": 0
			}
		],
		"weight": 4
	},
	{
		"id": 393,
		"name": "未来科技",
		"real": true,
		"parent": 163,
		"children": [],
		"weight": 17
	},
	{
		"id": 27,
		"name": "民族",
		"real": false,
		"parent": 163,
		"children": [{
				"id": 56,
				"name": "世界民族",
				"real": true,
				"parent": 27,
				"children": [],
				"weight": 0
			},
			{
				"id": 55,
				"name": "中国民族",
				"real": true,
				"parent": 27,
				"children": [],
				"weight": 0
			}
		],
		"weight": 11
	},
	{
		"id": 316,
		"name": "民谣",
		"real": true,
		"parent": 163,
		"children": [],
		"weight": 6
	},
	{
		"id": 311,
		"name": "氛围音乐",
		"real": true,
		"parent": 163,
		"children": [],
		"weight": 19
	},
	{
		"id": 25,
		"name": "流行",
		"real": false,
		"parent": 163,
		"children": [{
				"id": 123,
				"name": "Alternative pop",
				"real": true,
				"parent": 25,
				"children": [],
				"weight": 0
			},
			{
				"id": 44,
				"name": "Teen",
				"real": true,
				"parent": 25,
				"children": [],
				"weight": 0
			},
			{
				"id": 119,
				"name": "华语流行",
				"real": true,
				"parent": 25,
				"children": [],
				"weight": 0
			},
			{
				"id": 49,
				"name": "日韩流行",
				"real": true,
				"parent": 25,
				"children": [],
				"weight": 0
			},
			{
				"id": 414,
				"name": "欧美流行",
				"real": true,
				"parent": 25,
				"children": [],
				"weight": 0
			},
			{
				"id": 124,
				"name": "流行摇滚",
				"real": true,
				"parent": 25,
				"children": [],
				"weight": 0
			},
			{
				"id": 48,
				"name": "流行电子",
				"real": true,
				"parent": 25,
				"children": [],
				"weight": 0
			}
		],
		"weight": 16
	},
	{
		"id": 15,
		"name": "爵士",
		"real": false,
		"parent": 163,
		"children": [{
				"id": 53,
				"name": "Big Band/Swing",
				"real": true,
				"parent": 15,
				"children": [],
				"weight": 0
			},
			{
				"id": 37,
				"name": "Dixieland/Ragtime",
				"real": true,
				"parent": 15,
				"children": [],
				"weight": 0
			},
			{
				"id": 35,
				"name": "smooth jazz",
				"real": true,
				"parent": 15,
				"children": [],
				"weight": 0
			},
			{
				"id": 34,
				"name": "传统爵士/Bebop",
				"real": true,
				"parent": 15,
				"children": [],
				"weight": 0
			},
			{
				"id": 38,
				"name": "拉丁爵士",
				"real": true,
				"parent": 15,
				"children": [],
				"weight": 0
			},
			{
				"id": 125,
				"name": "融合爵士",
				"real": true,
				"parent": 15,
				"children": [],
				"weight": 0
			}
		],
		"weight": 8
	},
	{
		"id": 151,
		"name": "电子",
		"real": false,
		"parent": 163,
		"children": [{
				"id": 292,
				"name": "Ambient",
				"real": false,
				"parent": 151,
				"children": [],
				"weight": 0
			},
			{
				"id": 291,
				"name": "Breakbeat",
				"real": true,
				"parent": 151,
				"children": [],
				"weight": 0
			},
			{
				"id": 293,
				"name": "Drum & Bass/Jungle",
				"real": false,
				"parent": 151,
				"children": [],
				"weight": 0
			},
			{
				"id": 295,
				"name": "Dubstep",
				"real": false,
				"parent": 151,
				"children": [],
				"weight": 0
			},
			{
				"id": 298,
				"name": "Experimental",
				"real": false,
				"parent": 151,
				"children": [],
				"weight": 0
			},
			{
				"id": 300,
				"name": "Future Bass",
				"real": false,
				"parent": 151,
				"children": [],
				"weight": 0
			},
			{
				"id": 162,
				"name": "House/Dance/Progressive",
				"real": true,
				"parent": 151,
				"children": [],
				"weight": 0
			},
			{
				"id": 288,
				"name": "Lounge/Chillout",
				"real": true,
				"parent": 151,
				"children": [],
				"weight": 0
			},
			{
				"id": 294,
				"name": "Techno/Hardcore",
				"real": false,
				"parent": 151,
				"children": [],
				"weight": 0
			},
			{
				"id": 299,
				"name": "Trance",
				"real": false,
				"parent": 151,
				"children": [],
				"weight": 0
			},
			{
				"id": 289,
				"name": "Two Step/Garage",
				"real": true,
				"parent": 151,
				"children": [],
				"weight": 0
			},
			{
				"id": 395,
				"name": "迪斯科舞曲",
				"real": true,
				"parent": 151,
				"children": [],
				"weight": 0
			}
		],
		"weight": 15
	},
	{
		"id": 304,
		"name": "雷鬼/Ska",
		"real": true,
		"parent": 163,
		"children": [],
		"weight": 2
	}

]
//情绪
export let musicEmotionList_ = [{
		"id": 419,
		"name": "冥想/神游",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 1
	},
	{
		"id": 346,
		"name": "冷淡的",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 3
	},
	{
		"id": 341,
		"name": "励志的/振奋人心",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 13
	},
	{
		"id": 331,
		"name": "可爱/童真",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 6
	},
	{
		"id": 343,
		"name": "复古的",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 11
	},
	{
		"id": 339,
		"name": "奇幻/魔法",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 6
	},
	{
		"id": 178,
		"name": "好斗/急躁",
		"real": false,
		"parent": 164,
		"children": [],
		"weight": 7
	},
	{
		"id": 179,
		"name": "宽广/磅礴",
		"real": false,
		"parent": 164,
		"children": [],
		"weight": 8
	},
	{
		"id": 336,
		"name": "庄重的",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 2
	},
	{
		"id": 400,
		"name": "庆典",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 5
	},
	{
		"id": 348,
		"name": "异域的",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 1
	},
	{
		"id": 415,
		"name": "忧郁/悲伤",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 9
	},
	{
		"id": 335,
		"name": "感性/抒情",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 12
	},
	{
		"id": 332,
		"name": "慵懒/魅惑",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 10
	},
	{
		"id": 183,
		"name": "戏剧的",
		"real": false,
		"parent": 164,
		"children": [],
		"weight": 2
	},
	{
		"id": 420,
		"name": "放松/惬意",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 10
	},
	{
		"id": 342,
		"name": "时尚的",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 11
	},
	{
		"id": 334,
		"name": "浪漫/爱情",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 12
	},
	{
		"id": 345,
		"name": "清新的",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 11
	},
	{
		"id": 180,
		"name": "温馨/幸福",
		"real": false,
		"parent": 164,
		"children": [],
		"weight": 12
	},
	{
		"id": 417,
		"name": "滑稽/搞笑",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 6
	},
	{
		"id": 344,
		"name": "燃烧的",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 7
	},
	{
		"id": 338,
		"name": "狂野的",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 7
	},
	{
		"id": 347,
		"name": "科技感的",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 4
	},
	{
		"id": 177,
		"name": "积极/明快",
		"real": false,
		"parent": 164,
		"children": [],
		"weight": 13
	},
	{
		"id": 340,
		"name": "空灵的",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 3
	},
	{
		"id": 333,
		"name": "紧张的",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 7
	},
	{
		"id": 418,
		"name": "荒诞/离奇",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 1
	},
	{
		"id": 337,
		"name": "辉煌的",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 8
	},
	{
		"id": 350,
		"name": "运动",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 5
	},
	{
		"id": 416,
		"name": "阴暗/惊悚",
		"real": true,
		"parent": 164,
		"children": [],
		"weight": 1
	}
]

//乐器
export let musicInstrumentList_ = [

	{
		"id": 195,
		"name": "Turntable/Scratching",
		"real": false,
		"parent": 165,
		"children": [],
		"weight": 4
	},
	{
		"id": 323,
		"name": "人声",
		"real": false,
		"parent": 165,
		"children": [],
		"weight": 7
	},
	{
		"id": 412,
		"name": "人声歌词类",
		"real": true,
		"parent": 165,
		"children": [],
		"weight": 7
	},
	{
		"id": 409,
		"name": "低音号",
		"real": true,
		"parent": 165,
		"children": [],
		"weight": 5
	},
	{
		"id": 406,
		"name": "单簧管",
		"real": true,
		"parent": 165,
		"children": [],
		"weight": 2
	},
	{
		"id": 407,
		"name": "双簧管",
		"real": true,
		"parent": 165,
		"children": [],
		"weight": 2
	},
	{
		"id": 322,
		"name": "口琴/风琴",
		"real": false,
		"parent": 165,
		"children": [],
		"weight": 6
	},
	{
		"id": 193,
		"name": "合成器",
		"real": true,
		"parent": 165,
		"children": [],
		"weight": 9
	},
	{
		"id": 318,
		"name": "大提琴",
		"real": true,
		"parent": 165,
		"children": [],
		"weight": 10
	},
	{
		"id": 411,
		"name": "小号",
		"real": true,
		"parent": 165,
		"children": [],
		"weight": 5
	},
	{
		"id": 317,
		"name": "小提琴",
		"real": true,
		"parent": 165,
		"children": [],
		"weight": 10
	},
	{
		"id": 401,
		"name": "尤克丽丽",
		"real": true,
		"parent": 165,
		"children": [],
		"weight": 11
	},
	{
		"id": 191,
		"name": "弦乐组",
		"real": true,
		"parent": 165,
		"children": [],
		"weight": 10
	},
	{
		"id": 197,
		"name": "打击乐",
		"real": true,
		"parent": 165,
		"children": [],
		"weight": 8
	},
	{
		"id": 413,
		"name": "无旋律",
		"real": true,
		"parent": 165,
		"children": [],
		"weight": 1
	},
	{
		"id": 188,
		"name": "木吉他",
		"real": true,
		"parent": 165,
		"children": [],
		"weight": 11
	},
	{
		"id": 320,
		"name": "木管乐器",
		"real": false,
		"parent": 165,
		"children": [],
		"weight": 3
	},
	{
		"id": 324,
		"name": "架子鼓",
		"real": false,
		"parent": 165,
		"children": [],
		"weight": 8
	},
	{
		"id": 198,
		"name": "民族乐器",
		"real": false,
		"parent": 165,
		"children": [],
		"weight": 6
	},
	{
		"id": 189,
		"name": "电吉他",
		"real": false,
		"parent": 165,
		"children": [],
		"weight": 11
	},
	{
		"id": 186,
		"name": "电钢琴/Organ",
		"real": false,
		"parent": 165,
		"children": [],
		"weight": 12
	},
	{
		"id": 196,
		"name": "电鼓",
		"real": false,
		"parent": 165,
		"children": [],
		"weight": 8
	},
	{
		"id": 405,
		"name": "短笛/长笛",
		"real": true,
		"parent": 165,
		"children": [],
		"weight": 6
	},
	{
		"id": 404,
		"name": "竖琴",
		"real": true,
		"parent": 165,
		"children": [],
		"weight": 6
	},
	{
		"id": 192,
		"name": "管乐组",
		"real": false,
		"parent": 165,
		"children": [],
		"weight": 5
	},
	{
		"id": 319,
		"name": "萨克斯",
		"real": true,
		"parent": 165,
		"children": [],
		"weight": 2
	},
	{
		"id": 187,
		"name": "贝斯",
		"real": false,
		"parent": 165,
		"children": [],
		"weight": 11
	},
	{
		"id": 408,
		"name": "钟",
		"real": true,
		"parent": 165,
		"children": [],
		"weight": 1
	},
	{
		"id": 185,
		"name": "钢琴",
		"real": false,
		"parent": 165,
		"children": [],
		"weight": 12
	},
	{
		"id": 402,
		"name": "铁琴",
		"real": true,
		"parent": 165,
		"children": [],
		"weight": 6
	},
	{
		"id": 321,
		"name": "铜管乐器",
		"real": false,
		"parent": 165,
		"children": [],
		"weight": 3
	},
	{
		"id": 410,
		"name": "长号",
		"real": true,
		"parent": 165,
		"children": [],
		"weight": 5
	},
	{
		"id": 403,
		"name": "风笛",
		"real": true,
		"parent": 165,
		"children": [],
		"weight": 6
	}
]
//速度
export let musicSpeedList_ = [{
		"id": 201,
		"name": "0-45",
		"real": false,
		"parent": 166,
		"children": [],
		"weight": 0
	},
	{
		"id": 202,
		"name": "45-63",
		"real": false,
		"parent": 166,
		"children": [],
		"weight": 0
	},
	{
		"id": 203,
		"name": "63-78",
		"real": false,
		"parent": 166,
		"children": [],
		"weight": 0
	},
	{
		"id": 204,
		"name": "78-95",
		"real": false,
		"parent": 166,
		"children": [],
		"weight": 0
	},
	{
		"id": 205,
		"name": "95-130",
		"real": false,
		"parent": 166,
		"children": [],
		"weight": 0
	},
	{
		"id": 206,
		"name": "130-160",
		"real": false,
		"parent": 166,
		"children": [],
		"weight": 0
	},
	{
		"id": 207,
		"name": "160+",
		"real": false,
		"parent": 166,
		"children": [],
		"weight": 0
	},
	{
		"id": 208,
		"name": "散板/无固定速度",
		"real": false,
		"parent": 166,
		"children": [],
		"weight": 0
	}
]
//时长
export let musicDurationList_ = [{
	"id": 6001,
	"name": "小于30秒",
	"real": false,
	"parent": 600,
	"children": [],
	"weight": 0,
	"start":0,
	"end":30
},{
	"id": 6002,
	"name": "30秒-1分钟",
	"real": false,
	"parent": 600,
	"children": [],
	"weight": 0,
	"start":30,
	"end":60
},{
	"id": 6003,
	"name": "1分钟-2分钟",
	"real": false,
	"parent": 166,
	"children": [],
	"weight": 0,
	"start":60,
	"end":120
},{
	"id": 6004,
	"name": "2分钟-3分钟",
	"real": false,
	"parent": 166,
	"children": [],
	"weight": 0,
	"start":120,
	"end":180
},{
	"id": 6005,
	"name": "3分钟以上",
	"real": false,
	"parent": 600,
	"children": [],
	"weight": 0,
	"start":180,
	"end":''
}



]



// WEBPACK FOOTER //
// ./src/config/js/setConfig.js